import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery';
import { Grid, Button } from '@mui/material'
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import "./home.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";
import { useNavigate } from 'react-router-dom';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "swiper/css/scrollbar";

import { Scrollbar } from "swiper";
import Banner1 from "assets/Image/ImgHome/Banner1.jpg";
import Banner2 from "assets/Image/ImgHome/Banner2.jpg";
import Banner3 from "assets/Image/ImgHome/Banner3.jpg";
import { i18n } from 'i18n';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
const i18nField = 'entities.Banner.fields';
const Banner = (props) => {

    const { DataUser } = props

    const Layout1300 = useMediaQuery('(min-width:1300px)');
    const Layout1000 = useMediaQuery('(min-width:1000px)');
    const Layout600 = useMediaQuery('(min-width:600px)');
    const navigate = useNavigate();

    return (
        <>
            <Swiper
                spaceBetween={0}
                slidesPerView={1}
                speed={2000}
                loop={true}
                rewind={true}
                centeredSlides={true}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: true,
                }}
                pagination={{
                    clickable: true,
                    type: "fraction",
                }}
                scrollbar={{
                    hide: true,
                }}
                navigation={true}
                modules={[Pagination, Autoplay, Navigation, Scrollbar]}
                className="mySwiper"
            >
                <SwiperSlide>
                    <>
                        <div style={{ position: 'absolute', top: !Layout1000 ? '20%' : '35%', left: '10%' }}>
                            <Grid container spacing={Layout1000 ? 4 : 1} direction="row" justifyContent="start" alignItems="center" style={{ textAlign: 'left', color: '#ffffff' }}>
                                <Grid item xs={12}>
                                    <span style={{ fontWeight: Layout600 ? "400" : "600", display: "flex", fontSize: Layout1300 ? "3em" : Layout1000 ? "2em" : Layout600 ? "22px" : "10px" }}>
                                        {i18n(`${i18nField}.sEnquireInfo`)}
                                    </span>{" "}
                                    <span style={{ fontWeight: Layout600 ? "400" : "600", fontSize: Layout1300 ? "3.2em" : Layout1000 ? "2.1em" : Layout600 ? "22px" : "10px" }}>
                                        {i18n(`${i18nField}.sVOC2`)}
                                    </span>
                                </Grid>
                                <Grid item xs={12}>
                                    {
                                        currentLanguage() == "th" ?
                                            (
                                                Layout600 ?
                                                    <span style={{ fontWeight: "400", fontSize: Layout1300 ? "1.2em" : Layout1000 ? "1em" : "16px" }}>
                                                        ข้อสอบถามของท่าน เราจะดำเนินการพิจารณาพร้อมติดต่อกลับอย่างรวดเร็ว
                                                    </span>
                                                    :
                                                    <span style={{ fontWeight: "400", fontSize: "10px" }}>
                                                        ข้อสอบถามของท่าน<br />เราจะดำเนินการพิจารณา<br />พร้อมติดต่อกลับอย่างรวดเร็ว
                                                    </span>
                                            )
                                            :
                                            (
                                                Layout600 ?
                                                    <span style={{ fontWeight: "400", fontSize: Layout1300 ? "1.2em" : Layout1000 ? "1em" : Layout600 ? "16px" : "10px" }}>
                                                        Your question is important for us. <br />We will quickly consider and contact your inquiry.
                                                    </span>
                                                    :
                                                    <span style={{ fontWeight: "400", fontSize: Layout1300 ? "1.2em" : Layout1000 ? "1em" : Layout600 ? "16px" : "10px" }}>
                                                        Your question is important for us. <br />We will quickly consider <br />and contact your inquiry.
                                                    </span>
                                            )
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    {
                                        DataUser.sUserType === "C"
                                            ?
                                            <Button
                                                variant="outlined"
                                                size={Layout1300 ? "large" : Layout1000 ? "medium" : "small"}
                                                className={"button-banner"}
                                                startIcon={<SmsOutlinedIcon style={{ color: '#ffffff' }} />}
                                                onClick={() => { navigate("/Front/VOCForm") }}
                                            >
                                                {i18n(`${i18nField}.sEnquireInfo`)}
                                            </Button>
                                            : null
                                    }
                                </Grid>
                            </Grid>
                        </div>
                        <img src={Banner1} alt='Banner' />
                    </>
                </SwiperSlide>
                <SwiperSlide>
                    <>
                        <div style={{ position: 'absolute', top: !Layout1000 ? '20%' : '35%', left: '10%' }}>
                            <Grid container spacing={Layout1000 ? 4 : 1} direction="row" justifyContent="start" alignItems="center" style={{ textAlign: 'left', color: '#ffffff' }}>
                                <Grid item xs={12}>
                                    <span style={{ fontWeight: Layout600 ? "400" : "600", display: "flex", fontSize: Layout1300 ? "3em" : Layout1000 ? "2em" : Layout600 ? "22px" : "10px" }}>
                                        {i18n(`${i18nField}.sSuggest`)}{" "}{i18n(`${i18nField}.sComment`)}
                                    </span>{" "}
                                </Grid>
                                <Grid item xs={12}>
                                    {
                                        currentLanguage() == "th" ?
                                            (
                                                Layout600 ?
                                                    <span style={{ fontWeight: "400", fontSize: Layout1300 ? "1.2em" : Layout1000 ? "1em" : "16px" }}>
                                                        คำแนะนำติชมของท่าน มีความสำคัญอย่างยิ่งสำหรับเรา<br />เราจะเร่งตรวจสอบและศึกษา<br />เพื่อนำไปพัฒนาให้ผลิตภัณฑ์และบริการที่ดีมากยิ่งขึ้น
                                                    </span>
                                                    :
                                                    <span style={{ fontWeight: "400", fontSize: "10px" }}>
                                                        คำแนะนำติชมของท่าน <br />มีความสำคัญอย่างยิ่งสำหรับเรา<br />เราจะเร่งตรวจสอบและศึกษา<br />เพื่อนำไปพัฒนาให้ผลิตภัณฑ์<br />และบริการที่ดีมากยิ่งขึ้น
                                                    </span>
                                            )
                                            :
                                            (
                                                Layout600 ?
                                                    <span style={{ fontWeight: "400", fontSize: Layout1300 ? "1.2em" : Layout1000 ? "1em" : Layout600 ? "16px" : "10px" }}>
                                                        Your complaint and recommendation is important for us.<br />We will quickly verify and develop to be the best product.
                                                    </span>
                                                    :
                                                    <span style={{ fontWeight: "400", fontSize: Layout1300 ? "1.2em" : Layout1000 ? "1em" : Layout600 ? "16px" : "10px" }}>
                                                        Your complaint and recommendation <br />is important for us.<br />We will quickly verify <br />and develop to be the best product.
                                                    </span>
                                            )
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        variant="outlined"
                                        size={Layout1300 ? "large" : Layout1000 ? "medium" : "small"}
                                        className={"button-banner"}
                                        startIcon={<SmsOutlinedIcon style={{ color: '#ffffff' }} />}
                                        onClick={() => { navigate("/Front/SuggestionForm") }}
                                    >
                                        {i18n(`${i18nField}.sSendFeedback`)}
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                        <img src={Banner2} alt='Banner' />
                    </>
                </SwiperSlide>
                <SwiperSlide>
                    <>
                        <div style={{ position: 'absolute', top: !Layout1000 ? '20%' : '35%', left: '10%' }}>
                            <Grid container spacing={Layout1000 ? 4 : 1} direction="row" justifyContent="start" alignItems="center" style={{ textAlign: 'left', color: '#ffffff' }}>
                                <Grid item xs={12}>
                                    <span style={{ fontWeight: Layout600 ? "400" : "600", display: "flex", fontSize: Layout1300 ? "3em" : Layout1000 ? "2em" : Layout600 ? "22px" : "10px" }}>
                                        {i18n(`${i18nField}.sReportcomplaints`)}
                                    </span>{" "}
                                    <span style={{ fontWeight: Layout600 ? "400" : "600", fontSize: Layout1300 ? "3.2em" : Layout1000 ? "2.1em" : Layout600 ? "22px" : "10px" }}>
                                        {i18n(`${i18nField}.sVOC2`)}
                                    </span>
                                </Grid>
                                <Grid item xs={12}>
                                    {
                                        currentLanguage() == "th" ?
                                            (
                                                Layout600 ?
                                                    <span style={{ fontWeight: "400", fontSize: Layout1300 ? "1.2em" : Layout1000 ? "1em" : "16px" }}>
                                                        ข้อร้องเรียนของท่าน มีความสำคัญอย่างยิ่งสำหรับเรา เราจะทำอย่างดีที่สุด<br />เพื่อปรับปรุงแก้ไข เรียนรู้ วิเคราะห์ พร้อมวางแผนป้องกัน<br />เพื่อให้ทุกผลิตภัณฑ์และบริการของเราดีที่สุดสำหรับท่าน
                                                    </span>
                                                    :
                                                    <span style={{ fontWeight: "400", fontSize: "10px" }}>
                                                        ข้อร้องเรียนของท่าน มีความสำคัญอย่างยิ่งสำหรับเรา<br />เราจะทำอย่างดีที่สุด เพื่อปรับปรุงแก้ไข<br /> เรียนรู้ วิเคราะห์ พร้อมวางแผนป้องกัน<br />เพื่อให้ทุกผลิตภัณฑ์<br />และบริการของเราดีที่สุดสำหรับท่าน
                                                    </span>
                                            )
                                            :
                                            (
                                                Layout600 ?
                                                    <span style={{ fontWeight: "400", fontSize: Layout1300 ? "1.2em" : Layout1000 ? "1em" : Layout600 ? "16px" : "10px" }}>
                                                        Your complaint and recommendation is important for us.<br />We will analyze, improve and plan to be the best product and service for you.
                                                    </span>
                                                    :
                                                    <span style={{ fontWeight: "400", fontSize: Layout1300 ? "1.2em" : Layout1000 ? "1em" : Layout600 ? "16px" : "10px" }}>
                                                        Your complaint and recommendation <br />is important for us.<br />We will analyze, improve <br />and plan to be the best product <br />and service for you.
                                                    </span>
                                            )
                                    }
                                </Grid>
                                {
                                    DataUser.sUserType === "C"
                                        ?
                                        <Grid item xs={12}>
                                            <Button
                                                variant="outlined"
                                                size={Layout1300 ? "large" : Layout1000 ? "medium" : "small"}
                                                // style={{ backgroundColor: '#1773ea', color: '#ffffff', borderRadius: '25px' }}
                                                className={"button-banner"}
                                                startIcon={<CampaignRoundedIcon style={{ color: '#ffffff' }} />}
                                                onClick={() => { navigate("/Front/VOCForm") }}
                                            >
                                                {i18n(`${i18nField}.sReportcomplaints`)}
                                            </Button>
                                        </Grid>
                                        : null
                                }
                            </Grid>
                        </div>
                        <img src={Banner3} alt='Banner' />
                    </>
                </SwiperSlide>
            </Swiper>
        </>
    )
}

export default Banner